import React from "react";
import PrimaryLayout from "../layout/PrimaryLayout";
import { Navigate } from "react-router-dom";
import Agreement from "../pages/Agreement";
import Policy from "../pages/Policy";
export const pcRouter: any = [
  {
    path: "/",
    element: <PrimaryLayout />,
  },
  {
    path: "/agreement",
    element: <Agreement />,
  },
  {
    path: "/policy",
    element: <Policy />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

